<template>
	<div>
		<loading-anim v-if="$store.state.loading" :active="$store.state.loading" fullScreen></loading-anim>
		<b-navbar class="os-navbar" :class="{ 'fixed-scroll': isFixedScrolled }" :toggleable="isToggleable">
			<b-navbar-toggle id="navbar-toggler" target="nav-collapse">
				<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/menu-icon.svg" :color="color" :style="{ color: color }" :width="iconSize" :height="iconSize"/>
			</b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav v-model="collapseVisible" v-click-outside="hideMenu">
				<b-navbar-nav class="ml-0 ml-desktop-auto ml-xl-auto">
					<b-nav-item class="mr-0 mr-lg-2">
						<lang-selector enablePortuguese>
						</lang-selector>
					</b-nav-item>
					<slot name="nav-items"></slot>
					<!-- <b-nav-item class="mx-auto d-contents d-desktop-none d-tablets-rotated-none d-xl-none">
						<AddToHomeScreen></AddToHomeScreen>
					</b-nav-item> -->
					<slot name="nav-btn-items"></slot>
				</b-navbar-nav>
			</b-collapse>
			<b-navbar-brand href="/"><img :class="getLogoClasses" :style="getLogoStyles" :src="getLogo" /></b-navbar-brand>
			<b-nav-item class="d-xl-none d-desktop-none d-block">
				<button @click="() => { $router.push('/inicio-sesion') }" class="navbar-toggler">
					<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/profile.svg" :color="color" :width="iconSize" :height="iconSize"/>
				</button>
			</b-nav-item>
			</b-navbar>
		<div>
			<slot name="heading"></slot>
			<router-view v-slot="{ Component }" v-if="!showTabContent || !$uiHelpers.isXlDevice">
				<transition name="fade" mode="out-in">
					<component :is="Component" />
				</transition>
			</router-view>
			<AddToHomeScreen v-if="showInstallAppButton" animate shadow class="add-to-home-screen"></AddToHomeScreen>
		</div>
	</div>
</template>

<script>
import layoutMixin from '@/mixins/layout.mixin'
import gtagMixin from '@/mixins/gtag.mixin'
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'
import { BLUE_COLOUR } from '@/constants/colours'
import AddToHomeScreen from '@/components/utils/AddToHomeScreen'

const LI_ELEMENT_HEIGHT = 51

export default {
	name: 'PublicMenuLayoutV2',
	vcoConfig: {
		middleware: this.processClickOutside
	},
	mixins: [layoutMixin, gtagMixin],
	components: {
		'loading-anim': () => import('@/components/utils/LoadingAnim'),
		'lang-selector': () => import('@/components/base/LangSelector'),
		BNavbar,
		BNavbarNav,
		BNavbarBrand,
		BNavbarToggle,
		BCollapse,
		BNavItem,
		AddToHomeScreen
	},
	props: {
		showInstallAppButton: {
			type: Boolean,
			default: false
		},
		showLangSelector: {
			type: Boolean,
			default: true
		},
		showTabContent: {
			type: Boolean,
			default: false
		},
		privateMenuLayout: {
			type: Boolean,
			default: false
		},
		invertedColorsMobile: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			isFixedScrolled: false,
			BLUE_COLOUR,
			collapseVisible: false
		}
	},
	methods: {
		handleScroll () {
			this.isFixedScrolled = window.scrollY > 50
		},
		processClickOutside (event) {
			return !(event.target.closest('#navbar-toggler') || event.target.closest('#nav-collapse'))
		},
		hideMenu (event) {
			// Check clicked element or parent element is not navbar-toggler
			if (!event.target.closest('#navbar-toggler') && !this.$uiHelpers.isDesktop && this.collapseVisible) {
				this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
				// Do it in next tick
				setTimeout(() => {
					this.collapseVisible = false
				}, 0)
			}
		},
		setDropdownMenuTopMargin () {
			var visibleMenuElements = [...document.querySelectorAll('#nav-collapse li')].filter(el => window.getComputedStyle(el).display !== 'none')
			const dropdownMenuHeight = visibleMenuElements.length * LI_ELEMENT_HEIGHT
			const navbarHeight = document.querySelector('.os-navbar').offsetHeight
			document.documentElement.style.setProperty('--margin-top-dropdown-menu', `${dropdownMenuHeight + navbarHeight}px`)
		}
	},
	mounted () {
		window.addEventListener('scroll', this.handleScroll)
		// Reload page when orientation change
		window.addEventListener('orientationchange', () => {
			window.location.reload()
		})
		this.setDropdownMenuTopMargin()
	},
	computed: {
		iconSize () {
			return this.$uiHelpers.isMobile ? 21 : 23
		},
		hasHeadingSlot () {
			return !!this.$slots.heading
		},
		hasNavCollapseMobileSlot () {
			return !!this.$slots['nav-collapse-mobile']
		},
		isToggleable () {
			return !this.$uiHelpers.isDesktop || this.$uiHelpers.isPortrait
		},
		color () {
			return this.$uiHelpers.isMobileOrTablet && this.invertedColorsMobile ? 'white' : BLUE_COLOUR
		}
	}
}
</script>

<style scoped lang="scss">
	$border-radius-fixed-menu: 18px;

	:root {
		--margin-top-dropdown-menu: 0px;
	}

	/deep/.os-navbar {
    flex-wrap: initial;
    width: 100%;
    z-index: 5;
		position: fixed;
		flex-direction: initial;
    @include container-padding;

		@include tablets {
			padding: {
				top: 1.5rem;
				bottom: 1.5rem;
			}
		}

		@include media(mobile, desktop-sm) {
			padding: {
				top: .3rem;
				bottom: 0;
			}
			z-index: 1000;
		}

		.nav-item {
			margin: {
				top: auto;
				bottom: auto;
			}
		}

		.nav-link {
			color: $blue;
			font-weight: 600;
			transition: all .5s ease;

			&:not(:has(.btn)):not(.nav-item-profile) {
				&:hover {
					transform: scale(1.05);
					transition: all .5s ease;
				}
			}
		}

		@include media(desktop) {
			flex-direction: row-reverse;

			.navbar-brand {
				margin-right: auto;
			}

			.nav-item {
				padding: {
					right: 1rem;
					left: 1rem;
				}
			}
		}

		@include media(tablets-rotated) {
			.nav-item {
				padding: {
					right: 0rem;
				}
			}
		}

		/* transform: translate3d(0, 0, 0);
			transition: 0.1s all ease-out; */
		&.fixed-scroll {
			background-color: #ffffffdd;

			@include media(mobile, tablets) {
				background-color:  #1D1D1Ddd;
			}

			box-shadow: -10px -10px 35px #fff, 10px 10px 35px rgba(13,39,80,0.160784);
			border-bottom-left-radius: $border-radius-fixed-menu;
			border-bottom-right-radius: $border-radius-fixed-menu;
			transform: translate3d(0, 0, 0);
			transition: 0.1s all ease-out;
		}

		@include media(mobile, tablets, desktop-sm) {
			.navbar-brand {
				margin-right: 0;
			}

			/* .collapsing {
				-webkit-transition: none;
				transition: none;
				display: none;
			} */

			.collapse {
				margin-top:  var(--margin-top-dropdown-menu);

				.navbar-nav {
					padding: 1rem;
				}

				/* transition: all .5s ease; */
				opacity: 1;
				text-align: center;
				background-color: $white;
				border-radius: $border-radius;
				box-shadow: $custom-shadow-bottom;
				position: fixed;
			}

			.nav-link {
				padding: 0;
			}

			.nav-item {
				padding: {
					top: 1rem;
					bottom: 1rem;
				}

				p {
					padding: 0;
					margin: 0;
				}
			}
		}
	}

	.add-to-home-screen {
		position: fixed;
		@include desktop { 
			bottom: 2rem;
			left: 3rem;
		}
		bottom: 1rem;
		left: 2rem;
		z-index: 1000;
		font-weight: bold;
		text-transform: uppercase;
	}

</style>


// WEBPACK FOOTER //
// src/components/layouts/PublicMenuLayoutV2.vue